import '../../styles/LocationModal.scss';

import React, { PureComponent } from 'react';
import { Button, Form, Grid } from 'semantic-ui-react';
import { getCurrentPosition } from '../../../helpers/LocationUtility';
import { ValueChangedForFieldFunc } from '../../formeditor-types';
import GfModal from '../../../gfcomponents/GfModal/GfModal';

export type LocationTextModalProps = {
  name?: string;
  value?: string;
  onClose?: VoidFunction;
  valueUpdated?: ValueChangedForFieldFunc;
};

export default class LocationTextModal extends PureComponent<LocationTextModalProps, TypeMePlease> {
  constructor(props) {
    super(props);

    this.handleDialogModalClose = this.handleDialogModalClose.bind(this);
    this.handleClearButtonClicked = this.handleClearButtonClicked.bind(this);
    this.handleCancelButtonClicked = this.handleCancelButtonClicked.bind(this);
    this.handleDoneButtonClicked = this.handleDoneButtonClicked.bind(this);
    this.handleGetLocationButtonClicked = this.handleGetLocationButtonClicked.bind(this);

    this.state = {
      longitude: null,
      latitude: null,
      accuracy: null,
      isLoading: false
    };
  }

  componentDidMount() {
    if (!this.props.value) {
      this.getGpsLocation();
    }
  }

  getGpsLocation() {
    this.setState({ isLoading: true });

    getCurrentPosition({
      timeout: 10000, // 10 seconds
      maximumAge: 5 * 60000, // 5 minutes
      enableHighAccuracy: true
    })
      .then(({ coords }) => {
        this.setState({
          latitude: coords.latitude,
          longitude: coords.longitude,
          accuracy: Math.round(coords.accuracy),
          isLoading: false,
          error: null
        });
      })
      .catch(() => {
        this.setState({ error: 'Location not available', latitude: null, longitude: null, accuracy: null, isLoading: false });
      });
  }

  handleGetLocationButtonClicked() {
    this.getGpsLocation();
  }

  handleClearButtonClicked() {
    this.props.valueUpdated({ value: '' });
    this.props.onClose();
  }

  handleDialogModalClose() {
    this.props.onClose();
  }

  handleCancelButtonClicked() {
    this.props.onClose();
  }

  handleDoneButtonClicked() {
    if (this.state.latitude) {
      let newValue = null;
      if (this.props.value) {
        newValue = JSON.parse(this.props.value);
        newValue.Latitude = this.state.latitude;
        newValue.Longitude = this.state.longitude;
        newValue.Accuracy = this.state.accuracy;
      } else {
        newValue = {
          Latitude: this.state.latitude,
          Longitude: this.state.longitude,
          Accuracy: this.state.accuracy
        };
      }
      this.props.valueUpdated({ value: JSON.stringify(newValue) });
    } else if (this.state.error) {
      this.props.valueUpdated({ value: JSON.stringify({ Error: this.state.error }) });
    }

    this.props.onClose();
  }

  render() {
    let latitude = null;
    let longitude = null;
    let accuracy = null;

    let locationData = null;

    if (this.state.isLoading) {
      locationData = <div className="ui inverted text loader">Acquiring Location</div>;
    } else if (this.state.latitude || this.props.value) {
      if (this.state.latitude) {
        latitude = this.state.latitude;
        longitude = this.state.longitude;
        accuracy = this.state.accuracy;
      } else {
        const properties = JSON.parse(this.props.value);
        latitude = properties.Latitude;
        longitude = properties.Longitude;
        accuracy = properties.Accuracy;
      }
      locationData = (
        <Form>
          <Form.Field>
            <label>Latitude</label>
            <span>{latitude}</span>
          </Form.Field>
          <Form.Field>
            <label>Longitude</label>
            <span>{longitude}</span>
          </Form.Field>
          <Form.Field>
            <label>Accuracy</label>
            <span>{accuracy}m</span>
          </Form.Field>
        </Form>
      );
    }
    return (
      <GfModal
        title={this.props.name}
        className="location-modal"
        primaryText="Done"
        tertiaryText="Cancel"
        onPrimaryClick={this.handleDoneButtonClicked}
        onTertiaryClick={this.handleCancelButtonClicked}
        onClose={this.handleDialogModalClose}
        semanticUiModalProps={{ size: 'tiny', closeOnDimmerClick: true }}
      >
        <Grid>
          <Grid.Column floated="left" width={8}>
            <Button onClick={this.handleClearButtonClicked} className="clear" floated="left">
              Clear
            </Button>
          </Grid.Column>
          <Grid.Column floated="right" width={8}>
            <Button onClick={this.handleGetLocationButtonClicked} className="getlocation" floated="right">
              <i className="map pin icon" />
              Acquire Location
            </Button>
          </Grid.Column>
        </Grid>
        {locationData}
      </GfModal>
    );
  }
}
